import type { SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

/**
 * Mobile Safari zooms the viewport when focusing text inputs whose computed font-size is below ~16px.
 *
 * Merge this object **last** in Autocomplete or TextField `sx` arrays so it overrides field-specific
 * typography (for example `fontSize: '0.9rem'` on `.MuiAutocomplete-input`).
 */
export function getFormAutocompleteMobileInputZoomSx(theme: Theme): SxProps<Theme> {
  // Tests sometimes render with a partial theme mock that omits `theme.utils`.
  const fontSize = theme.utils?.important?.('1rem') ?? '1rem !important';
  return {
    [theme.breakpoints.down('sm')]: {
      '& .MuiAutocomplete-input': {
        fontSize,
      },
      '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
        fontSize,
      },
      '& .MuiInput-root .MuiAutocomplete-input': {
        fontSize,
      },
      '& .MuiInputBase-input': {
        fontSize,
      },
    },
  };
}
